import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getConfigPtMonDigital } from "./services";

const initialState: any = {
  status: "",
  data: [],
};

export const actionGetConfigPtMonDigital: any = createAsyncThunk<any, any>(
  "ACTION_GET_CONFIG_PT_MON_DIGITAL",
  async (_, { getState }: any) => {
    const {
      modulosByCentral: {
        entradaSelected: {
          modulo: { idCentral, adrModulo },
          entrada,
        },
      },
    } = getState();
    return getConfigPtMonDigital({
      idCentral,
      adrModulo,
      idEntrada: entrada.id,
    });
  }
);

const sliceGetConfigPtMonDigital = createSlice({
  name: "GET_CONFIG",
  initialState,
  reducers: {
    actionResetGetConfigPtMonDigital: (state) => {
      state.data = [];
    },
  },
  extraReducers: {
    [actionGetConfigPtMonDigital.pending]: (state) => {
      state.status = "loading";
    },
    [actionGetConfigPtMonDigital.fulfilled]: (state, { payload }) => {
      state.status = "success";
      state.data = {
        ...payload,
        hrMsgEscaladaNV2: payload.timeMsgEscaladaNV2?.split(":")[0],
        minMsgEscaladaNV2: payload.timeMsgEscaladaNV2?.split(":")[1],
        hrMsgEscaladaNV3: payload.timeMsgEscaladaNV3?.split(":")[0],
        minMsgEscaladaNV3: payload.timeMsgEscaladaNV3?.split(":")[1],
      };
    },
    [actionGetConfigPtMonDigital.rejected]: (state, err) => {
      console.log(err);
      state.status = "error";
    },
  },
});

export default sliceGetConfigPtMonDigital.reducer;
export const { actionResetGetConfigPtMonDigital } =
  sliceGetConfigPtMonDigital.actions;
